<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="公司名称">
          <el-input v-model="searchData.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="searchData.tel"></el-input>
        </el-form-item>
        <el-form-item label="销售人员">
          <!-- <el-input v-model="searchData.salesmanId"></el-input> -->
          <el-select
            v-model="searchData.salesmanId"
            placeholder="请选择客户来源"
            clearable
          >
            <el-option
              :label="item.name"
              :value="item.salesmanId"
              v-for="(item, index) in salesmanUserList2"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家类型">
          <el-popover
            ref="searchIndustryTreePopover"
            placement="bottom-start"
            trigger="click"
            width="300"
            @show="onSearchIndustryPopoverShow"
          >
            <el-input
              v-model="searchIndustryFilterText"
              size="small"
              placeholder="输入名称筛选"
              clearable
              style="margin-bottom: 8px"
            ></el-input>
            <el-tree
              ref="searchIndustryTree"
              :data="industryList"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              highlight-current
              :expand-on-click-node="false"
              :filter-node-method="filterIndustryNode"
              @node-click="handleSearchIndustryNodeClick"
            ></el-tree>
          </el-popover>
          <el-input
            v-model="searchData.industry"
            placeholder="请选择商家类型"
            readonly
            v-popover:searchIndustryTreePopover
            style="cursor: pointer; width: 180px"
          >
            <i
              v-if="searchData.industry"
              slot="suffix"
              class="el-input__icon el-icon-circle-close"
              style="cursor: pointer"
              @click.stop="clearSearchIndustry"
            ></i>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="公司年营收">
          <el-select v-model="searchData.revenue" clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in revenueList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="btn">
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="refresh"
            >查询</el-button
          >
        </el-button-group>
      </div>
      <div>
        <el-button-group>
          <!-- <el-button type="primary" size="small" @click="exportMatch"
            >智能匹配导出</el-button
          > -->
          <el-button type="primary" size="small" @click="refresh"
            >刷新</el-button
          >
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              {{ scope.row.tel }}
            </template>
          </el-table-column>
          <el-table-column label="商家类型" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.shop_industry_name || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="来源" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.source || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="公司年营收">
            <template slot-scope="scope">
              {{ scope.row.revenue }}
            </template>
          </el-table-column>
          <el-table-column label="录入时间">
            <template slot-scope="scope">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <div class="action-btn-wrap">
              <el-button type="primary" size="mini" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button type="primary" size="mini" @click="openSupplyDemand(scope.row, 1)"
                >供给</el-button
              >
              <el-button type="primary" size="mini" @click="openSupplyDemand(scope.row, 2)"
                >需求</el-button
              >
              <el-button type="primary" size="mini" @click="followUp(scope.row)"
                >跟进客户</el-button
              >
              <el-button type="primary" size="mini" @click="followUpList(scope.row)"
                >跟进记录</el-button
              >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="商家类型">
          <el-popover
            ref="industryTreePopover"
            placement="bottom-start"
            trigger="click"
            width="300"
            @show="onShopIndustryPopoverShow"
          >
            <el-input
              v-model="shopIndustryFilterText"
              size="small"
              placeholder="输入名称筛选"
              clearable
              style="margin-bottom: 8px"
            ></el-input>
            <el-tree
              ref="shopIndustryTree"
              :data="industryList"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              highlight-current
              :expand-on-click-node="false"
              :filter-node-method="filterIndustryNode"
              @node-click="handleIndustryNodeClick"
            ></el-tree>
          </el-popover>
          <el-input
            v-model="shopIndustryName"
            placeholder="请选择商家类型"
            readonly
            v-popover:industryTreePopover
            style="cursor: pointer"
          ></el-input>
        </el-form-item>
        <el-form-item label="营收情况">
          <el-select v-model="form.revenue" placeholder="请选择营收情况">
            <el-option
              v-for="(item, index) in revenueList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司介绍">
          <el-input v-model="form.Introduction" type="textarea" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="上游公司">
          <div class="shop-tags">
            <el-tag
              v-for="(tag, index) in upstreamShopTags"
              :key="'upstream-' + index"
              closable
              size="small"
              @close="removeShopTag('upstream', index)"
            >{{ tag }}</el-tag>
            <el-input
              v-model="upstreamShopInput"
              class="shop-tag-input"
              size="small"
              :placeholder="upstreamShopTags.length >= maxShopTags ? `最多${maxShopTags}个` : '请输入公司名称'"
              @keyup.enter.native="addShopTag('upstream')"
            >
              <el-button
                slot="append"
                size="small"
                @click="addShopTag('upstream')"
              >添加</el-button>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="下游公司">
          <div class="shop-tags">
            <el-tag
              v-for="(tag, index) in downstreamShopTags"
              :key="'downstream-' + index"
              closable
              size="small"
              @close="removeShopTag('downstream', index)"
            >{{ tag }}</el-tag>
            <el-input
              v-model="downstreamShopInput"
              class="shop-tag-input"
              size="small"
              :placeholder="downstreamShopTags.length >= maxShopTags ? `最多${maxShopTags}个` : '请输入公司名称'"
              @keyup.enter.native="addShopTag('downstream')"
            >
              <el-button
                slot="append"
                size="small"
                @click="addShopTag('downstream')"
              >添加</el-button>
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="supplyDemandDialogTitle"
      :visible.sync="supplyDemandDialogVisible"
      width="1200px"
      :before-close="supplyDemandHandleClose"
    >
      <el-form :inline="true" :model="supplyDemandForm" class="demo-form-inline">
        <el-form-item label="商家类型">
          <el-popover
            ref="supplyDemandIndustryTreePopover"
            placement="bottom-start"
            trigger="click"
            width="300"
            @show="onSupplyDemandIndustryPopoverShow"
          >
            <el-input
              v-model="supplyDemandIndustryFilterText"
              size="small"
              placeholder="输入名称筛选"
              clearable
              style="margin-bottom: 8px"
            ></el-input>
            <el-tree
              ref="supplyDemandIndustryTree"
              :data="industryList"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              highlight-current
              :expand-on-click-node="false"
              :filter-node-method="filterIndustryNode"
              @node-click="handleSupplyDemandIndustryNodeClick"
            ></el-tree>
          </el-popover>
          <el-input
            v-model="supplyDemandIndustryName"
            placeholder="请选择商家类型"
            readonly
            v-popover:supplyDemandIndustryTreePopover
            style="cursor: pointer; width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="紧急程度" v-if="supplyDemandForm.type == 2">
          <el-select v-model="supplyDemandForm.emergency" placeholder="请选择">
            <el-option label="高" :value="1"></el-option>
            <el-option label="中" :value="2"></el-option>
            <el-option label="低" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供需说明">
          <el-input v-model="supplyDemandForm.content" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="supplyDemandSubmit">{{ supplyDemandForm.id ? '更新' : '添加' }}</el-button>
          <el-button @click="supplyDemandReset">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="supplyDemandList"
        size="small"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column label="商家类型" min-width="120" width="260">
          <template slot-scope="scope">
            {{ getIndustryName(industryList, scope.row.shop_industry_id) || scope.row.industry || scope.row.shop_industry_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="supplyDemandForm.type == 2"
          label="紧急程度"
          width="100"
        >
          <template slot-scope="scope">
            {{ formatEmergency(scope.row.emergency) }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="供需说明"></el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="supplyDemandEdit(scope.row)">编辑</el-button>
            <el-button type="primary" size="mini" @click="supplyDemandExport(scope.row)">导出</el-button>
            <el-button type="danger" size="mini" @click="supplyDemandDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="跟进客户"
      :visible.sync="followUpShow"
      width="700px"
      :before-close="handleFollowUpClose"
    >
      <el-form
        :model="form3"
        ref="ruleForm3"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="备注">
          <el-input v-model="form3.remark" type="textarea" rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFollowUpClose">取 消</el-button>
        <el-button type="primary" @click="followUpSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="跟进记录"
      :visible.sync="followUpListShow"
      width="700px"
      :before-close="handleFollowUpClose"
    >
      <el-table
        ref="followUpTable"
        :data="followUpListData"
        tooltip-effect="dark"
        style="width: 100%"
        size="small"
        border
        stripe
        :header-cell-style="{ background: '#545c64', color: '#fff' }"
      >
        <el-table-column label="跟进人员">
          <template slot-scope="scope">
            {{ scope.row.admin }}
          </template>
        </el-table-column>
        <el-table-column label="备注信息">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="跟进时间">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="followUpDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="handleFollowUpClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      list: {},
      revenueList: [],
      industryList: [],
      salesmanUserList2: [],
      shopIndustryName: "",
      shopIndustryFilterText: "",
      searchIndustryFilterText: "",
      supplyDemandIndustryName: "",
      supplyDemandIndustryFilterText: "",
      dialogVisible: false,
      dialogTitle: "编辑商家详情",
      form: {
        id: "",
        customer_id: "",
        shop_industry_id: "",
        revenue: "",
        Introduction: "",
        upstream_shop: "",
        downstream_shop: "",
      },
      searchData: {
        name: "",
        tel: "",
        industry: "",
        revenue: "",
      },
      // 供需弹窗
      supplyDemandDialogVisible: false,
      supplyDemandDialogTitle: "",
      supplyDemandList: [],
      supplyDemandForm: {
        id: "",
        customer_id: "",
        shop_industry_id: "",
        type: 1,
        emergency: "",
        content: "",
      },
      multipleSelection: [],
      upstreamShopTags: [],
      downstreamShopTags: [],
      upstreamShopInput: "",
      downstreamShopInput: "",
      maxShopTags: 6,
      followUpShow: false,
      followUpListShow: false,
      followUpListData: [],
      followUpCustomerId: "",
      form3: {
        id: "",
        remark: "",
      },
    };
  },
  mounted() {
    this.getData();
    this.getRevenueList();
    this.getIndustryList();
    this.getSalesmanUserList();
    this.token = Cookie.get("token");
  },
  watch: {
    searchIndustryFilterText(val) {
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("searchIndustryTree", val);
      });
    },
    shopIndustryFilterText(val) {
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("shopIndustryTree", val);
      });
    },
    supplyDemandIndustryFilterText(val) {
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("supplyDemandIndustryTree", val);
      });
    },
  },
  methods: {
    getSalesmanUserList() {
      this.$axios.post("/api/customer/salesmanList").then((res) => {
        this.salesmanUserList2 = res.data.data;
      });
    },
    getRevenueList() {
      this.$axios
        .post("/api/shop/revenue", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.code == 1) {
            this.revenueList = res.data.data || [];
          }
        });
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getData() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchData.name,
        tel: this.searchData.tel,
        industry: this.searchData.industry,
        salesmanId: this.searchData.salesmanId,
        revenue: this.searchData.revenue,
      };
      this.$axios
        .post("/api/shop/index", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            this.list = res.data.data;
          }
        });
    },
    exportMatch() {
      this.$axios
        .post("/api/shop/exportMatch", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.code == 1) {
            if (res.data.data) {
              const a = document.createElement("a");
              a.setAttribute("download", "");
              a.setAttribute("href", res.data.data);
              a.click();
            } else {
              this.$message.warning("没有匹配到数据");
            }
          } else {
            this.$message.error(res.data.msg || "导出失败");
          }
        });
    },
    getIndustryList() {
      this.$axios
        .post("/api/shop_industry/index", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.code == 1) {
            this.industryList = res.data.data || [];
            if (this.form.shop_industry_id) {
              this.syncShopIndustryName();
            }
            if (this.supplyDemandForm.shop_industry_id) {
              this.syncSupplyDemandIndustryName();
            }
          }
        });
    },
    filterIndustryNode(value, data) {
      if (!value) return true;
      return data.name && data.name.indexOf(value) !== -1;
    },
    collapseIndustryTree(tree) {
      if (!tree || !tree.store || !tree.store.nodesMap) return;
      Object.keys(tree.store.nodesMap).forEach((key) => {
        tree.store.nodesMap[key].expanded = false;
      });
    },
    applyIndustryTreeFilter(refName, filterText) {
      const tree = this.$refs[refName];
      if (!tree) return;
      const keyword = (filterText || "").trim();
      tree.filter(keyword);
      if (!keyword) {
        this.collapseIndustryTree(tree);
      }
    },
    resetSearchIndustryFilter() {
      this.searchIndustryFilterText = "";
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("searchIndustryTree", "");
      });
    },
    resetShopIndustryFilter() {
      this.shopIndustryFilterText = "";
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("shopIndustryTree", "");
      });
    },
    resetSupplyDemandIndustryFilter() {
      this.supplyDemandIndustryFilterText = "";
      this.$nextTick(() => {
        this.applyIndustryTreeFilter("supplyDemandIndustryTree", "");
      });
    },
    onSearchIndustryPopoverShow() {
      this.resetSearchIndustryFilter();
    },
    onShopIndustryPopoverShow() {
      this.resetShopIndustryFilter();
    },
    onSupplyDemandIndustryPopoverShow() {
      this.resetSupplyDemandIndustryFilter();
    },
    handleSearchIndustryNodeClick(data) {
      this.searchData.industry = data.name;
      this.resetSearchIndustryFilter();
      this.$refs.searchIndustryTreePopover.doClose();
    },
    clearSearchIndustry() {
      this.searchData.industry = "";
      this.resetSearchIndustryFilter();
      this.$nextTick(() => {
        const tree = this.$refs.searchIndustryTree;
        if (tree) {
          tree.setCurrentKey(null);
        }
      });
    },
    handleIndustryNodeClick(data) {
      this.form.shop_industry_id = data.id;
      this.shopIndustryName = data.name;
      this.resetShopIndustryFilter();
      this.$refs.industryTreePopover.doClose();
    },
    handleSupplyDemandIndustryNodeClick(data) {
      this.supplyDemandForm.shop_industry_id = data.id;
      this.supplyDemandIndustryName = data.name;
      this.resetSupplyDemandIndustryFilter();
      this.$refs.supplyDemandIndustryTreePopover.doClose();
    },
    formatEmergency(val) {
      const map = { 1: "高", 2: "中", 3: "低" };
      return map[Number(val)] || "-";
    },
    getIndustryName(list, id) {
      if (!id && id !== 0) return "";
      for (let item of list) {
        if (item.id == id) return item.name;
        if (item.children && item.children.length) {
          const name = this.getIndustryName(item.children, id);
          if (name) return name;
        }
      }
      return "";
    },
    syncShopIndustryName() {
      this.shopIndustryName =
        this.getIndustryName(this.industryList, this.form.shop_industry_id) || "";
    },
    syncSupplyDemandIndustryName() {
      this.supplyDemandIndustryName =
        this.getIndustryName(this.industryList, this.supplyDemandForm.shop_industry_id) || "";
    },
    edit(row) {
      this.form.customer_id = row.id;
      this.getDetail(row.id);
    },
    getDetail(customerId) {
      // 预留接口，暂无真实接口
      this.$axios
        .post("/api/shop/info", this.$qs.stringify({ customer_id: customerId }))
        .then((res) => {
          if (res.data.code == 1 && res.data.data) {
            // 有数据，走编辑
            this.form = { ...res.data.data };
            this.initShopTagsFromForm();
            this.syncShopIndustryName();

            this.dialogTitle = "编辑商家详情";
          } else {
            // 无数据，走新增
            this.form = {
              id: "",
              customer_id: customerId,
              shop_industry_id: "",
              revenue: "",
              Introduction: "",
              upstream_shop: "",
              downstream_shop: "",
            };
            this.resetShopTags();
            this.shopIndustryName = "";
            this.dialogTitle = "新增商家详情";
          }
          this.dialogVisible = true;
        });
      // 预留接口，暂无真实接口，先直接打开弹窗
      // this.form = {
      //   id: "",
      //   customer_id: customerId,
      //   shop_industry_id: "",
      //   revenue: "",
      //   Introduction: "",
      //   upstream_shop: "",
      //   downstream_shop: "",
      // };
      // this.dialogTitle = "新增商家详情";
      // this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        customer_id: "",
        shop_industry_id: "",
        revenue: "",
        Introduction: "",
        upstream_shop: "",
        downstream_shop: "",
      };
      this.resetShopTags();
      this.shopIndustryName = "";
      this.resetShopIndustryFilter();
    },
    parseShopTags(str) {
      if (str === undefined || str === null || str === "") return [];
      return String(str)
        .split(/[,，]/)
        .map((s) => s.trim())
        .filter((s) => s)
        .slice(0, this.maxShopTags);
    },
    initShopTagsFromForm() {
      this.upstreamShopTags = this.parseShopTags(this.form.upstream_shop);
      this.downstreamShopTags = this.parseShopTags(this.form.downstream_shop);
      this.upstreamShopInput = "";
      this.downstreamShopInput = "";
      this.form.upstream_shop = this.upstreamShopTags.join(",");
      this.form.downstream_shop = this.downstreamShopTags.join(",");
    },
    resetShopTags() {
      this.upstreamShopTags = [];
      this.downstreamShopTags = [];
      this.upstreamShopInput = "";
      this.downstreamShopInput = "";
    },
    syncFormShopTags() {
      this.form.upstream_shop = this.upstreamShopTags.join(",");
      this.form.downstream_shop = this.downstreamShopTags.join(",");
    },
    addShopTag(type) {
      const isUpstream = type === "upstream";
      const inputKey = isUpstream ? "upstreamShopInput" : "downstreamShopInput";
      const tagsKey = isUpstream ? "upstreamShopTags" : "downstreamShopTags";
      const label = isUpstream ? "上游公司" : "下游公司";
      const tags = this[tagsKey];
      const max = this.maxShopTags;
      const val = (this[inputKey] || "").trim();

      if (tags.length >= max) {
        this.$message.warning(`${label}最多添加${max}个`);
        return;
      }
      if (!val) return;

      const parts = val.split(/[,，]/).map((s) => s.trim()).filter((s) => s);
      const uniqueParts = [];
      parts.forEach((p) => {
        if (!uniqueParts.includes(p) && !tags.includes(p)) {
          uniqueParts.push(p);
        }
      });

      if (!uniqueParts.length) {
        this[inputKey] = "";
        return;
      }

      const available = max - tags.length;
      if (uniqueParts.length > available) {
        uniqueParts.slice(0, available).forEach((p) => tags.push(p));
        this[inputKey] = "";
        this.$message.warning(`${label}最多添加${max}个`);
        return;
      }

      uniqueParts.forEach((p) => tags.push(p));
      this[inputKey] = "";
    },
    removeShopTag(type, index) {
      const tagsKey = type === "upstream" ? "upstreamShopTags" : "downstreamShopTags";
      this[tagsKey].splice(index, 1);
    },
    submit() {
      this.syncFormShopTags();
      this.$confirm("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.form.id) {
          // 编辑
          this.$axios
            .post("/api/shop/edit_info", this.$qs.stringify(this.form))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("操作成功");
                this.handleClose();
                this.getData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          // 新增
          this.$axios
            .post("/api/shop/add_info", this.$qs.stringify(this.form))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("操作成功");
                this.handleClose();
                this.getData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }).catch(() => {});
    },
    // 供需相关
    openSupplyDemand(row, type) {
      this.supplyDemandForm.type = type;
      this.supplyDemandForm.customer_id = row.id;
      this.supplyDemandIndustryName = "";
      this.supplyDemandDialogTitle = type == 1 ? "供给" : "需求";
      this.supplyDemandDialogVisible = true;
      this.getSupplyDemandList();
    },
    getSupplyDemandList() {
      this.$axios
        .post("/api/shop/supply_and_demand_list", this.$qs.stringify({
          customer_id: this.supplyDemandForm.customer_id,
          type: this.supplyDemandForm.type,
        }))
        .then((res) => {
          if (res.data.code == 1) {
            this.supplyDemandList = res.data.data || [];
          }
        });
    },
    supplyDemandEdit(row) {
      this.supplyDemandForm = {
        id: row.id,
        customer_id: this.supplyDemandForm.customer_id,
        shop_industry_id: row.shop_industry_id,
        type: this.supplyDemandForm.type,
        emergency: row.emergency,
        content: row.content,
      };
      this.syncSupplyDemandIndustryName();
    },
    supplyDemandReset() {
      this.supplyDemandForm = {
        id: "",
        customer_id: this.supplyDemandForm.customer_id,
        shop_industry_id: "",
        type: this.supplyDemandForm.type,
        emergency: "",
        content: "",
      };
      this.supplyDemandIndustryName = "";
      this.resetSupplyDemandIndustryFilter();
    },
    supplyDemandSubmit() {
      if (!this.supplyDemandForm.shop_industry_id) {
        this.$message.warning("请选择商家类型");
        return;
      }
      if (!this.supplyDemandForm.content) {
        this.$message.warning("请输入供需说明");
        return;
      }
      if (this.supplyDemandForm.type == 2 && !this.supplyDemandForm.emergency) {
        this.$message.warning("请选择紧急程度");
        return;
      }
      this.$confirm("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { ...this.supplyDemandForm };
        if (params.type == 1) {
          params.emergency = 0;
        }
        let api = this.supplyDemandForm.id ? "/api/shop/edit_supply_and_demand" : "/api/shop/add_supply_and_demand";
        this.$axios.post(api, this.$qs.stringify(params)).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.supplyDemandReset();
            this.getSupplyDemandList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => {});
    },
    supplyDemandExport(row) {
      this.$axios
        .post("/api/shop/supply_export", this.$qs.stringify({
          id: row.id,
        }))
        .then((res) => {
          if (res && res.data.code == 1) {
            if (res.data.data) {
              const a = document.createElement("a");
              let url = res.data.data;
              a.setAttribute("download", "");
              a.setAttribute("href", url);
              a.click();
            } else {
              this.$message.warning("没有可导出的数据");
            }
          } else if (res && res.data) {
            this.$message.error(res.data.msg || res.data.errorMsg || "导出失败");
          }
        });
    },
    supplyDemandDel(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/api/shop/del_supply_and_demand", this.$qs.stringify({
            id: row.id,
            customer_id: this.supplyDemandForm.customer_id,
          }))
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success("删除成功");
              this.getSupplyDemandList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }).catch(() => {});
    },
    supplyDemandHandleClose() {
      this.supplyDemandDialogVisible = false;
      this.supplyDemandReset();
      this.supplyDemandIndustryName = "";
      this.resetSupplyDemandIndustryFilter();
    },
    followUp(row) {
      this.form3.id = row.id;
      this.form3.remark = "";
      this.followUpShow = true;
    },
    followUpList(row) {
      this.followUpCustomerId = row.id;
      this.$axios
        .post("/api/shop/remark_list", this.$qs.stringify({ id: row.id }))
        .then((res) => {
          if (res.data.code == 1) {
            this.followUpListData = res.data.data || [];
            this.followUpListShow = true;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    followUpSubmit() {
      if (!this.form3.remark) {
        this.$message.warning("请输入备注");
        return;
      }
      this.$confirm("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/api/shop/remark_add", this.$qs.stringify(this.form3))
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success("操作成功");
              this.handleFollowUpClose();
              this.getData();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }).catch(() => {});
    },
    followUpDel(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/api/shop/remark_del", this.$qs.stringify({ id: row.id }))
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success("删除成功");
              this.$axios
                .post("/api/shop/remark_list", this.$qs.stringify({ id: this.followUpCustomerId }))
                .then((res) => {
                  if (res.data.code == 1) {
                    this.followUpListData = res.data.data || [];
                  }
                });
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }).catch(() => {});
    },
    handleFollowUpClose() {
      this.followUpShow = false;
      this.followUpListShow = false;
      this.followUpCustomerId = "";
      this.form3 = {
        id: "",
        remark: "",
      };
      this.followUpListData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100% !important;
}
.action-btn-wrap {
   display: flex;
   flex-wrap: wrap;
   gap: 4px;
 }
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .fromClass2 {
    width: 90%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
    display: flex;
    align-content: center;
  }
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.shop-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
  .el-tag {
    margin-right: 0;
  }
  .shop-tag-input {
    width: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/businessResource/index.vue